import(/* webpackMode: "eager" */ "/app/src/app/interview/history/page.tsx");
